<template>
  <div>
    <h1>Overview</h1>
    <div class="flex center v_center column">
      <iframe src="https://giphy.com/embed/ZrFwg4fN1vZyo" width="480" height="432" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>
      <h2 style="margin-top: 15px;">To be Continued..</h2>
    </div>
  </div>
</template>

<script>
  import MainLayout from "../layouts/MainLayout"
  export default {
    data() {
      return {}
    },
    components: {
      MainLayout
    },

  }
</script>
